import { useEffect, useState, useCallback } from 'react';
import { useRouter } from 'next/router';
import { ServiceSpinner } from '@services/ServiceSpinner';

const DONE_DURATION = 250;

const RouterSpinner = () => {
  const [timeoutId, setTimeoutId] = useState(null);
  const router = useRouter();
  const onRouteChangeStart = useCallback(() => {
    ServiceSpinner.show();
  }, []);

  const onRouteChangeDone = useCallback(() => {
    ServiceSpinner.hide();
    setTimeoutId(
      setTimeout(() => {
        setTimeoutId(null);
        ServiceSpinner.hide();
      }, DONE_DURATION),
    );
  }, []);

  useEffect(() => {
    router.events.on('routeChangeStart', onRouteChangeStart);
    router.events.on('routeChangeComplete', onRouteChangeDone);
    router.events.on('routeChangeError', onRouteChangeDone);

    return () => {
      router.events.off('routeChangeStart', onRouteChangeStart);
      router.events.off('routeChangeComplete', onRouteChangeDone);
      router.events.on('routeChangeError', onRouteChangeDone);
    };
  }, [onRouteChangeStart, onRouteChangeDone, router.events]);

  useEffect(
    () => () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    },
    [timeoutId],
  );

  return <></>;
};

export default RouterSpinner;
